<template>
  <div class="dash-section">
    <div class="header">
      <div>
        <h2 class="title">Registrations Over Time</h2>
      </div>
      <div class="actions section-header-offset">
        <span class="sr-only">Filter date range</span>
        <div class="dates">
          <label>
            <span class="sr-only">From</span>
            <input :value="from" type="date" :max="through" @input="setFrom" />
          </label>
          <font-awesome-icon
            :icon="['fas', 'long-arrow-alt-right']"
            class="icon alt between-dates"
            aria-hidden="true"
          />
          <label>
            <span class="sr-only">To</span>
            <input
              :value="through"
              type="date"
              :min="from"
              @input="setThrough"
            />
          </label>
        </div>
      </div>
    </div>
    <div class="chart-wrap">
      <label class="chart-control">
        <span class="sr-only">chart is segmented by {{ binBy }}</span>
        <select :value="binBy" @input="setBinBy">
          <option value="year">Yearly</option>
          <option value="quarter">Quarterly</option>
          <option value="month">Monthly</option>
          <option value="week">Weekly</option>
          <option value="day">Daily</option>
        </select>
      </label>

      <div v-if="loading" class="skeleton progress pb-5" style="height: 169px">
        <span class="sr-only">Loading Chart</span>
      </div>
      <registrations-over-time-chart
        v-else
        :binned-from="binnedFrom"
        :through="through"
        :bin-by="binBy"
        :binned-registrations="binnedRegistrations"
      />
    </div>
  </div>
</template>

<script>
import RegistrationsOverTimeChart from './RegistrationsOverTimeChart.vue';

export default {
  name: 'RegistrationsOverTimeSection',

  components: {
    RegistrationsOverTimeChart
  },

  inject: ['registrationsReport'],

  computed: {
    loading() {
      return this.registrationsReport.loading;
    },

    from() {
      return this.registrationsReport.parameters.from;
    },
    through() {
      return this.registrationsReport.parameters.through;
    },
    binBy() {
      return this.registrationsReport.parameters.binBy;
    },

    binnedFrom() {
      return this.registrationsReport.data.binnedFrom;
    },
    binnedRegistrations() {
      return this.registrationsReport.data.binnedRegistrations;
    }
  },

  methods: {
    setFrom(e) {
      this.registrationsReport.setParameters({ from: e.target.value });
    },
    setThrough(e) {
      this.registrationsReport.setParameters({ through: e.target.value });
    },
    setBinBy(e) {
      this.registrationsReport.setParameters({ binBy: e.target.value });
    }
  }
};
</script>

<style lang="scss" scoped>
.dates {
  color-scheme: light;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #d1d1d1;
  padding: 0;
  margin: 0;
  height: 46px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-align: center;

  @media screen and (min-width: $md-min) {
    height: 46px;
    flex-wrap: nowrap;
  }

  label {
    margin: 0;
  }

  input {
    border: 0;
    background: transparent;
    line-height: 1;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    max-width: 143px;
    height: 46px;
    padding: 0 16px;
  }

  svg {
    opacity: 0.8;
  }

  &:hover {
    box-shadow: 0 2px 4px rgb(0 0 0 / 18%);
    border-color: #bababa;
  }
}

.chart-wrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;

  .chart-control {
    padding: 0 2.45rem;

    select {
      color: #6b6e88;
      border: none;
      font-weight: 500;
      font-size: 16px;
      border-radius: $border-radius;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      padding: 2px 0;

      &:hover {
        background: #e4e4e4;
        color: inherit;
      }
    }
  }
}
</style>
